import {NgModule} from '@angular/core';
import {sharedReducers} from './reducers';
import {StoreModule} from '@ngrx/store';
import {CmsService} from './services/cms.service';
import {EffectsModule} from '@ngrx/effects';
import {CmsEffects} from './effects/cms.effects';
import {CmsPageComponent} from './component/cms-page/cms-page.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {CmsBlockComponent} from "./component/cms-block/cms-block.component";

export const COMPONENTS = [
    CmsPageComponent,
    CmsBlockComponent
];

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('cms', sharedReducers),
        EffectsModule.forFeature([CmsEffects]),
        SharedModule,
        MatProgressSpinnerModule
    ],
    declarations: [COMPONENTS],
    providers: [CmsService],
    exports: [COMPONENTS]
})
export class CmsModule {
}
